export default [
  { path: '/classic', name: '(Sint-Niklaas)' },
  { path: '/connect', name: 'Connect (Temse)' },
]
